import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// Circle/Polygon mode toggles. MUI's exclusive group passes `null` when the
// active button is clicked again, which deselects (back to static).
const GeofenceDrawingToolbar = ({ activeMode, selectMode, disabled }) => (
    <ToggleButtonGroup exclusive size="small" value={activeMode} onChange={(_event, mode) => selectMode(mode)}>
        <ToggleButton value="circle" disabled={disabled}>
            Circle
        </ToggleButton>
        <ToggleButton value="polygon" disabled={disabled}>
            Polygon
        </ToggleButton>
    </ToggleButtonGroup>
);

export default GeofenceDrawingToolbar;
